import { render } from "./ListVideoView.vue?vue&type=template&id=4450e34e"
import script from "./ListVideoView.vue?vue&type=script&lang=js"
export * from "./ListVideoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__